import { jsx as _jsx } from "react/jsx-runtime";
import { Icons } from '@xbto/iconography';
import { theme } from '@xbto/design-system';
import { iconSizes } from './types';
export function Icon({ color, em = false, name, size: sizeName = 'md', }) {
    const size = typeof sizeName === 'number' ? sizeName : iconSizes[sizeName];
    const colorName = color !== null && color !== void 0 ? color : (em ? 'primary' : 'secondary');
    const fill = theme.color.text[colorName];
    const Icon = Icons[name];
    if (!Icon) {
        return null;
    }
    return _jsx(Icon, { width: size, height: size, fill: fill });
}
